import { getEnvironment } from './lib/environment';
import { cn } from './lib/utils';

/**
 * Full-width banner that makes a non-production environment obvious, ported
 * from the legacy hub's PageBanner. Green on local, purple on staging, and
 * nothing at all on production.
 *
 * Shown to everyone (not admin-gated) — it's a pure hostname check.
 */
export function EnvironmentBanner() {
  const env = getEnvironment();

  if (env === 'production') return null;

  const isStaging = env === 'staging';

  return (
    <div
      className={cn(
        'flex w-full items-center justify-center py-0.5 text-xs font-semibold text-white',
        isStaging ? 'bg-purple-600' : 'bg-green-700',
      )}
    >
      {isStaging ? 'Staging' : 'Local'}
    </div>
  );
}
